import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import es from './locales/es.json';
import en from './locales/en.json';
import pt from './locales/pt.json';
import de from './locales/de.json';
import fr from './locales/fr.json';
import it from './locales/it.json';

const resources = {
  es: { translation: es },
  en: { translation: en },
  pt: { translation: pt },
  de: { translation: de },
  fr: { translation: fr },
  it: { translation: it }
};

const SUPPORTED = ['es', 'en', 'pt', 'de', 'fr', 'it'];

function detectLanguage() {
  const stored = localStorage.getItem('language');
  if (stored && SUPPORTED.includes(stored)) return stored;
  const browser = (navigator.language || navigator.userLanguage || 'es').split('-')[0].toLowerCase();
  return SUPPORTED.includes(browser) ? browser : 'en';
}

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: detectLanguage(),
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

// Mantener <html lang> en sync con el idioma activo. Un lang que no coincide con
// el contenido hace que el navegador ofrezca/aplique traducción automática, que
// muta el DOM y provoca crashes de React (removeChild) en Radix Select/Tabs.
function applyHtmlLang(lng) {
  if (typeof document !== 'undefined' && document.documentElement) {
    document.documentElement.lang = (lng || 'es').split('-')[0];
  }
}
applyHtmlLang(i18n.language);
i18n.on('languageChanged', applyHtmlLang);

export default i18n;
